<img src="/assets/images/undraw/trypay/undraw_setup_wizard_r6mr.svg" />

<p class="read-only-dialog-text">Ta funkcja jest aktualnie niedostępna.</p>
<p class="read-only-dialog-text">
  <a href="https://payka.pl/blog/zamykamy-serwis-rachunki-imoje/" target="_blank" class="redirect"
    >Dowiedz się więcej</a
  >
</p>

<mat-dialog-actions align="start">
  <button mat-button matDialogClose cdkFocusInitial>Zamknij</button>
</mat-dialog-actions>
